import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import EmptyRow from '../../../components/Simple/EmptyRow';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCLabel from '../../../components/Simple/SMCLabel';
import {SMCSelect, SMCOption } from '../../../components/Simple/SMCSelect';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function ServiceDomainWizardBody({
    onCancel,
    onFinish,
    wizardVars,
    availableServerGroups,
    defaultServerGroup
}) {
    const { t } = useTranslation();

    const {
        name, setName,
        description, setDescription,
        company, setCompany,
        contact, setContact,
        email, setEmail,
        isTwoStepAuthenticationEnabled, setIsTwoStepAuthenticationEnabled,
        serverGroup, setServerGroup
    } = wizardVars;

    return (
        <>
            <SMCModalBody lineHeight="22px" labelWidth={200}>
                <SMCLabel>{t('SMP.CREATE_NEW_SERVICE_DOMAIN.LINE1')}</SMCLabel>
                <SMCLabel>
                    {t('SMP.CREATE_NEW_SERVICE_DOMAIN.LINE2')}&nbsp;
                    <b>{t('SMP.CREATE_NEW_SERVICE_DOMAIN.LINE3')}</b>
                </SMCLabel>

                <EmptyRow />

                {/* Service domain name */}
                <SMCTextInput
                    label={t('SMP.CREATE_NEW_SERVICE_DOMAIN.SERVICE_DOMAIN_NAME')}
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                {/* Description */}
                <SMCTextInput
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label={t('SMP.DESCRIPTION')}
                />
                {/* Company */}
                <SMCTextInput
                    value={company}
                    onChange={e => setCompany(e.target.value)}
                    label={t('SMP.CREATE_NEW_SERVICE_DOMAIN.COMPANY')}
                />
                {/* Contact */}
                <SMCTextInput
                    value={contact}
                    onChange={e => setContact(e.target.value)}
                    label={t('SMP.CREATE_NEW_SERVICE_DOMAIN.CONTACT')}
                />
                {/* Email */}
                <SMCTextInput
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    label={t('SMP.CREATE_NEW_SERVICE_DOMAIN.EMAIL')}
                />

                {/* Server Group */}
                <SMCSelect
                    value={serverGroup || defaultServerGroup}
                    onChange={e => setServerGroup(e.target.value)}
                    label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.SERVER_GROUP')}
                >
                    {
                        availableServerGroups && availableServerGroups.map(defaultServerGroupName => (
                            <SMCOption key={defaultServerGroupName} value={defaultServerGroupName}>{defaultServerGroupName}</SMCOption>
                        ))
                    }
                </SMCSelect>
                <SMCCheckbox
                    checked={isTwoStepAuthenticationEnabled}
                    onChange={e => setIsTwoStepAuthenticationEnabled(e.target.checked)}
                    label={t('SMP.CREATE_NEW_SERVICE_DOMAIN.ENABLE_2FA')}
                    labelPosition="start"
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default ServiceDomainWizardBody;